import { SET_FILTERS } from '../actions/filters';

const initialState = {
    filters: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_FILTERS:
            return {
                filters: action.payload
            };
        default:
            return state;
    }
};
